<template>
  <div style='color: #909399' class='password-tip'>
    <div :style='{color: password ? (validateNewPassword[0] ? "#61ad66" : "#F75C47") : "inherit"}'>
      <i class='el-icon-success password-tip-item'></i>密码由8-20位数字、大小写字母和特殊符号组成
    </div>

    <div :style='{color: password ? (validateNewPassword[1] ? "#61ad66" : "#F75C47") : "inherit"}'><i class='el-icon-success password-tip-item'></i>至少包含3种以上字符</div>
  </div>
</template>

<script>
import utils from '@/utils/utils';

export default {
  name: 'PasswordTip',
  props: ['password'],
  computed: {
    validateNewPassword() {
      return utils.validatePassword(this.password);
    }
  },
  methods: {
    runValidate() {
      if (!this.validateNewPassword[0] || !this.validateNewPassword[1]) {
        this.$message.warning('密码格式错误（需要至少包含8-20位数字、大小写字母或特殊符号三种类型）');
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang='less' scoped>
.password-tip {
  color: #909399;

  & > div:first-child {
    margin-bottom: 4px;
  }

  .password-tip-item {
    //color: #61ad66;
    font-size: 16px;
    vertical-align: middle;
    margin-right: 4px;
  }
}
</style>
